module.exports = __webpack_public_path__ + "static/media/monument_img_1.1d1f178c.png";